<p>
  The Units of Measure (UOM) describes the weight, volume or quantity of your
  product. We have two different pricing structures depending on the UOM of the
  product. Please make sure to use the correct UOM.
</p>
<form [formGroup]="uomFormGroup">
  <div class="product-detail-container">
    <div class="product-details-left">
      <h6>Select UOM</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>UOM</mat-label>
        <mat-select
          formControlName="UOM"
          [(ngModel)]="selectedUOMCategory"
          (selectionChange)="getSelectedUOM()"
          required
        >
          <mat-option
            *ngFor="let category of UOMCategoryList"
            [value]="category"
          >
            {{ category.name }}
          </mat-option>
        </mat-select>
        <mat-hint>Required form labels ends with an *</mat-hint>
        <mat-error *ngIf="uomFormGroup.get('UOM')?.hasError('required') && uomFormGroup.get('UOM')?.touched">
          UOM is Required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="product-details-right">
      <h6>How will you sell this product</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Measurement</mat-label>
        <mat-select
          formControlName="Measurement"
          [(ngModel)]="selectedUOMSubCategory"
          required
        >
          <mat-option
            *ngFor="let subCategory of UOMSubCategoryList"
            [value]="subCategory"
          >
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="uomFormGroup.get('Measurement')?.hasError('required') && uomFormGroup.get('Measurement')?.touched"
        >
          Measurement is Required
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="product-details-right"
      *ngIf="
        selectedUOMCategory?.name !== null &&
        selectedUOMCategory?.name !== undefined &&
        selectedUOMCategory?.name !== 'Units'
      "
    >
      <h6>How many units does it contain</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Units</mat-label>
        <input matInput formControlName="Units" appCurrencyDecimal />
        <mat-error *ngIf="uomFormGroup.get('Units')?.hasError('required') && uomFormGroup.get('Units')?.touched">
          Units is Required
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
